import React from "react";
import canUseDom from "../../../utils/can-use-dom";
import { SimpleSlider } from "../basic/simple-slider.js";
import { CollectionName } from "../basic/collection-name.js";
import { collectionSection } from "../collection-templates/collection-layout-helper";

import { wrapCollectionLayout } from "@quintype/components";

function FullscreenSimpleSliderBase({ collection, stories = [], config, associatedMetadata }) {
  const { show_collection_title: collectionName = true } = associatedMetadata;
  return (
    <div className="component-wrapper" data-test-id="full-screen-simple-slider">
      {collectionName ? <CollectionName name={collection.name} type="large" section={collection} /> : null}
      <SimpleSlider stories={stories} config={config} heading={collection.name} />
    </div>
  );
}

export const FullscreenSimpleSlider = wrapCollectionLayout(FullscreenSimpleSliderBase);
